import React from 'react';
import './App.css';
import '@buzztime-live-trivia-2.0/utils/src/glass-effects.css';
// Import logo and background image
import logo from '@buzztime-live-trivia-2.0/utils/assets/BLT_logo-1.png';
import backgroundImage from '@buzztime-live-trivia-2.0/utils/assets/icons.png';
import playerImage from '@buzztime-live-trivia-2.0/utils/assets/player.png';
import hostImage from '@buzztime-live-trivia-2.0/utils/assets/host.png';
import BuzztimeLogo from '@buzztime-live-trivia-2.0/utils/assets/BuzzLogo.png';
// Import social media icons
import { FaFacebook, FaInstagram, FaShareAlt } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FaMicrophone } from 'react-icons/fa';

function App() {
  // Function to handle social media sharing
  const handleShare = (platform) => {
    const shareUrl = window.location.href;
    const shareText = "Check out Buzztime Live Trivia - the ultimate trivia game experience!";
    
    let shareLink = "";
    
    switch(platform) {
      case 'facebook':
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'twitter':
        shareLink = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
        break;
      case 'instagram':
        // Instagram doesn't support direct web sharing, but we can open Instagram app/website
        shareLink = 'https://www.instagram.com/playbuzztime/';
        break;
      default:
        // Use Web Share API if available, otherwise fallback to clipboard
        if (navigator.share) {
          navigator.share({
            title: 'Buzztime Live Trivia',
            text: shareText,
            url: shareUrl,
          }).catch((error) => {
            // Handle the case where user cancels the share dialog
            if (error.name === 'AbortError') {
              // User canceled the share, do nothing
              console.log('Share canceled by user');
            } else {
              // Other errors, fallback to clipboard
              console.error('Share failed:', error);
              navigator.clipboard.writeText(shareUrl);
              alert("Link copied to clipboard!");
            }
          });
          return;
        } else {
          navigator.clipboard.writeText(shareUrl);
          alert("Link copied to clipboard!");
          return;
        }
    }
    
    window.open(shareLink, '_blank');
  };
  
  return (
    <div className="App">
      <div className="landing-container">
        {/* Left Column: 70% width */}
        <div className="left-column">
          {/* Top Section: 60% height */}
          <div className="top-section glass-base glass-rounded-xl glass-edge" style={{ backgroundImage: `url(${backgroundImage})` }}>
            {/* Navigation Bar */}
              <nav className="navbar">
              <div className="navbar-logo">
                <img src={BuzztimeLogo} alt="Buzztime Logo" className="nav-logo" />
              </div>
              <ul className="navbar-links">
                {/* <li><a href="#gameroom" className="active">Game Hub</a></li> */}
              </ul>
              <div className="social-links">
                <button onClick={() => handleShare('facebook')} aria-label="Share on Facebook">
                  <FaFacebook size={20} />
                </button>
                <button onClick={() => handleShare('twitter')} aria-label="Share on X">
                  <FaXTwitter size={20} />
                </button>
                <button onClick={() => handleShare('instagram')} aria-label="Visit Instagram">
                  <FaInstagram size={20} />
                </button>
                <button onClick={() => handleShare()} aria-label="Share">
                  <FaShareAlt size={20} />
                </button>
              </div>
              </nav>
            {/* Logo */}
            <img src={logo} alt="Buzztime Live Trivia Logo" className="app-logo" />
            <p className="legal-text"> {new Date().getFullYear()} All Rights Reserved - Buzztime Entertainment is an eGames.com company.</p>
          </div>
          
          {/* Bottom Section: 40% height, split into two columns */}
          <div className="bottom-section">
            {/* Bottom Left */}
            <div className="bottom-left glass-base glass-rounded-xl glass-edge" onClick={() => {
              const host = window.location.host;
              window.location.href = host.includes('localhost') ? 'http://localhost:3003/' : `${window.location.origin}/player`;
            }}>
              <h2 className="section-title">Join as a player</h2>
             {/* <FaMicrophone size={20} /> */}
              
            </div>
            
            {/* Bottom Right */}
            <div className="bottom-right glass-base glass-rounded-xl glass-edge" onClick={() => {
              const host = window.location.host;
              window.location.href = host.includes('localhost') ? 'http://localhost:3001/' : `${window.location.origin}/host`;
            }}>
              <h2 className="section-title">Host a game</h2>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
